<template>
    <div>
        <el-select v-model="value_temp" clearable filterable placeholder="试验结果" :disabled="disabled">
            <el-option value="合格"></el-option>
            <el-option value="不合格"></el-option>
        </el-select>
    </div>
</template>
<script>
    export default {
        props: {
            value: {
                default: ''
            },
            disabled: {
                default: false
            }
        },
        data() {
            return {
                value_temp: this.value
            }
        },
        watch: {
            value(val) {
                this.value_temp = val;
            },
            value_temp(val) {
                this.$emit('input', val);
            }
        },
    }
</script>
<style lang="scss" scoped>
    @import "index.scss";
</style>